/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./n1Tags.vue?vue&type=template&id=3632457c"
import script from "./n1Tags.vue?vue&type=script&lang=js"
export * from "./n1Tags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports